export const id_map = [
  {
    dataType: "text",
    description: "封面",
    flag: 0
  },
  {
    dataType: "text",
    description: "标题",
    flag: 1
  },
  {
    dataType: "text",
    description: "子标题",
    flag: 2
  },
  {
    dataType: "text",
    description: "作者",
    flag: 3
  },
  {
    dataType: "text",
    description: "简介",
    flag: 4
  },
  {
    dataType: "number",
    description: "数值",
    flag: 5
  },
  {
    dataType: "text",
    description: "发布时间",
    flag: 6
  },
  {
    dataType: "text",
    description: "标签说明",
    flag: 7
  },
  {
    dataType: "text",
    description: "文本1",
    flag: 100
  },
  {
    dataType: "text",
    description: "文本2",
    flag: 101
  },
  {
    dataType: "text",
    description: "文本3",
    flag: 102
  },
  {
    dataType: "text",
    description: "文本4",
    flag: 103
  },
  {
    dataType: "text",
    description: "文本5",
    flag: 104
  },
  {
    dataType: "text",
    description: "文本6",
    flag: 105
  },
  {
    dataType: "text",
    description: "文本7",
    flag: 106
  },
  {
    dataType: "text",
    description: "文本8",
    flag: 107
  },
  {
    dataType: "text",
    description: "文本9",
    flag: 108
  },
  {
    dataType: "text",
    description: "文本10",
    flag: 109
  },
  {
    dataType: "text",
    description: "文本11",
    flag: 110
  },
  {
    dataType: "text",
    description: "文本12",
    flag: 111
  }
]
export const key_lable_map = {
  author: "作者",
  introduction: "简介",
  title: "标题",
  subTitle: "子标题",
  publishTime: "发布时间"
}
const resultMap = {
  0: ["imageComponent"],
  1: ["cxText", "cxButton", "cxLabel"],
  2: ["cxText", "cxButton", "cxLabel"],
  3: ["cxText", "cxButton", "cxLabel"],
  4: ["cxText", "cxButton", "cxLabel"],
  5: ["cxDigitRoll"],
  6: ["cxText", "cxButton", "cxLabel"],
  7: ["cxText", "cxButton", "cxLabel"],
  8: ["cxText", "cxButton", "cxLabel"],
  100: ["cxText", "cxButton", "cxLabel"],
  101: ["cxText", "cxButton", "cxLabel"],
  102: ["cxText", "cxButton", "cxLabel"],
  103: ["cxText", "cxButton", "cxLabel"],
  104: ["cxText", "cxButton", "cxLabel"],
  105: ["cxText", "cxButton", "cxLabel"],
  106: ["cxText", "cxButton", "cxLabel"],
  107: ["cxText", "cxButton", "cxLabel"],
  108: ["cxText", "cxButton", "cxLabel"],
  109: ["cxText", "cxButton", "cxLabel"],
  110: ["cxText", "cxButton", "cxLabel"],
  111: ["imageComponent"],
  11: ["cxText", "cxButton", "cxLabel"]
}

//select * from resultMap where id_map[item].flagId === resultMap[flagId]
export function fixComponent(flagId, value) {
  if (IsDate(value) && !isImage(value)) {
    return ["cxText", "cxButton", "cxLabel", "cxDate"]
  }
  if (hasHtmlTags(value)) {
    return ["cxEditor"]
  }
  const idPoint = id_map.find(item => item.flag == flagId)
  if (!!idPoint && !!resultMap[idPoint.flag]) return resultMap[idPoint.flag]
  if (isImage(value)) {
    return ["imageComponent"]
  } else {
    return ["cxText", "cxButton", "cxLabel"]
  }
}

//正则校验是否是图片
export function isImage(str) {
  const reg = /\.(png|jpg|gif|jpeg|webp)$/
  return reg.test(str)
}

// 正则校验是否是html字符串
function hasHtmlTags(str) {
  // 定义HTML标签的正则表达式
  var htmlRegex = /<\s*\/?\s*[a-zA-Z]+\s*.*?>/g
  return htmlRegex.test(str)
}

/**
 * 正则匹配一下当前字段的值，可能是时间格式
 * yyyy-MM-dd HH:mm:ss
 * yyyy-MM-dd HH:mm
 */

//检查日期是否有效
function IsDate(mystring) {
  const YYYYMMReg = /[\d]{4}[\/-]{1}[\d]{1,2}/g
  // const YYYYMMDDReg = /[\d]{4}[\/-]{1}[\d]{1,2}[\/-]{1}[\d]{1,2}/g
  // const YYYYMMDDHHmmReg = /[\d]{4}[\/-]{1}[\d]{1,2}[\/-]{1}[\d]{1,2}\s[\d]{1,2}[:][\d]{1,2}/g
  // const YYYYMMDDHHmmssReg = /[\d]{4}[\/-]{1}[\d]{1,2}[\/-]{1}[\d]{1,2}\s[\d]{1,2}[:][\d]{1,2}[:][\d]{1,2}/g
  let str = mystring
  // if (!!YYYYMMDDHHmmssReg.exec(str) || !!YYYYMMDDReg.exec(str) || !!YYYYMMDDHHmmReg.exec(str) || !!YYYYMMReg.exec(str)) {
  // 时间格式不能大于20，解决有些文本里嵌套了时间也会被匹配成时间格式
  if (!!YYYYMMReg.exec(str) && str.length < 20) {
    let dateReg = new RegExp("[`!@$^&*()=|{}';',\\[\\]<>?！￥……（）【】‘；：”“'。，、？]")
    if(dateReg.test(str)){
      return false
    }else{
      return true
    }
  }
  return false
}
